import { useEffect, useState, useRef } from "react";
import { Button, CircularProgress, Grid, NativeSelect } from "@mui/material";
import { useForm } from 'react-hook-form'
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation } from 'react-query'
import { ValidationSchemaStyle } from "../services/schemaValidation";
import FlexibleWidthDialog from "components/Dialog/FlexibleWidthDialog"
import { updateStyle } from "../services/api";
import DialogImageManager from "routes/ImageManager/DialogImageManager";
import FormBuilder from "components/Inputs/FormBuilder";
import { useTranslation } from "react-i18next";
import { DataFields } from "./DataFields";
import { isEmptyObject } from "helpers";
import QRCodeStyling from "qr-code-styling"

export default function Style({ open, close, instance, reportAction }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false)
  const [dataInstance, setDataInstance] = useState({})
  const [imageManagerModalOpen, setImageManagerModalOpen] = useState(false)
  const [dataFieldImageManager, setDataFieldImageManager] = useState(null)
  let { reset, handleSubmit, register, formState: { errors }, setValue } = useForm({
    resolver: yupResolver(ValidationSchemaStyle)
  })
  const [qrCode] = useState(new QRCodeStyling({
    width: 300,
    height: 300,
    data: "https://qr-code-styling.com",
    margin: instance !== undefined ? instance.style_qr.margin : 0,
    qrOptions: { typeNumber: "0", mode: "Byte", errorCorrectionLevel: "Q" },
    image: null,
    imageOptions: { hideBackgroundDots: true, imageSize: 0.4, margin: 0 },
    backgroundOptions: {
      color: instance !== undefined ? instance.style_qr.background : "#ffffff"
    },
    dotsOptions: {
      type: instance !== undefined ? instance.style_qr.points_style : "square",
      color: instance !== undefined ? instance.style_qr.points_color : "#000000",
    },
    cornersSquareOptions: {
      type: instance !== undefined ? instance.style_qr.corners_square_style : "",
      color: instance !== undefined ? instance.style_qr.corners_square_color : "#000000",
    },
    cornersDotOptions: {
      type: instance !== undefined ? instance.style_qr.corners_dot_style : "",
      color: instance !== undefined ? instance.style_qr.corners_dot_color : "#000000",
    },
  }))
  const [fileExt, setFileExt] = useState("svg");
  const ref = useRef(null);

  useEffect(() => {
    if (open) { setDataInstance(instance.style_qr); reset(instance.style_qr); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  useEffect(() => {
    if(dataInstance !== undefined && !isEmptyObject(dataInstance)) {
      console.log("datainstance", dataInstance)
      qrCode.update({
        width: dataInstance.size,
        height: dataInstance.size,
        margin: dataInstance.margin,
        data: "https://qr-code-styling.co",
        qrOptions: { typeNumber: "0", mode: "Byte", errorCorrectionLevel: "Q" },
        image: dataInstance.image,
        imageOptions: { hideBackgroundDots: true, imageSize: 0.4, margin: 0 },
        backgroundOptions: {
          color: dataInstance.background
        },
        dotsOptions: {
          type: dataInstance.points_style,
          color: dataInstance.points_color,
        },
        cornersSquareOptions: {
          type: dataInstance.corners_square_style,
          color: dataInstance.corners_square_color,
        },
        cornersDotOptions: {
          type: dataInstance.corners_dot_style,
          color: dataInstance.corners_dot_color,
        }
      });
      qrCode.append(ref.current);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataInstance])

  const mutation = useMutation(updateStyle, {
    onSuccess: (data) => {
      setIsLoading(false)
      if (data.status === "error") {
        reportAction(false, 'Error al guardar los datos', 'error')
      } else {
        reset(); setDataInstance({});
        reportAction(true, 'Acción realizada correctamente', 'success')
      }
    }
  })

  const handleUpdateStyle = (params) => {
    setIsLoading(true)
    mutation.mutate({ id: instance._id, params: params })
  }

  const handleClose = () => { reset(); setDataInstance({}); close() }

  const handleOnChangeData = (event) => {
    if (event.target.name.includes(".")) {
      const separate = event.target.name.split(".")
      setDataInstance({ ...dataInstance, [separate[0]]: { ...dataInstance[separate[0]], [separate[1]]: event.target.value } })
      return;
    }
    setDataInstance({ ...dataInstance, [event.target.name]: event.target.value })
  }

  const handleChangeBoolean = (name) => {
    setDataInstance({ ...dataInstance, [name]: !dataInstance[name] })
  }

  /*Handlers Image manager */
  const handleOpenImageManager = () => { setImageManagerModalOpen(true) }
  const handleCloseImageManager = (prop) => { setImageManagerModalOpen(prop) }
  const handleFieldImageManager = (prop) => { setDataFieldImageManager(prop) }
  const handleSelectImageManager = (url) => {
    setDataInstance({ ...dataInstance, [dataFieldImageManager]: url })
    setValue(dataFieldImageManager, url)
  }

  /* onChange ColorPicker */
  const handleChangeCompletePicker = (color, field) => {
    setDataInstance({ ...dataInstance, [field]: color.hex })
    setValue(field, color.hex)
  }

  const handleOnExtensionChange = (e) => {
    setFileExt(e.target.value);
  };

  const handleOnDownloadClick = () => {
    if (!qrCode) return;
    qrCode.download({
      extension: fileExt
    });
  }

  const Actions = () => (<>
    {!isLoading ? <>
      <Button onClick={handleClose}>{t("button_text_cancel")}</Button>
      <Button variant="contained" color="info" onClick={handleSubmit(handleUpdateStyle)} disabled={isEmptyObject(dataInstance)} >{t("button_text_edit")}</Button>
    </> : <CircularProgress />}
  </>)

  return (<>
    <FlexibleWidthDialog maxWidth="md" open={open} title={t('qrcode_dialog_title_style')} actions={<Actions />}>
      <Grid container spacing={1}>
        <Grid item xs={12} md={6}>
          <FormBuilder
            dataDields={DataFields(t)}
            dataInstance={dataInstance}
            containerSelectOptions={{
              points_style: [
                { value: 'rounded', label: 'rounded' },
                { value: 'dots', label: 'dots' },
                { value: 'classy', label: 'classy' },
                { value: 'classy-rounded', label: 'classy-rounded' },
                { value: 'square', label: 'square' },
                { value: 'extra-rounded', label: 'extra-rounded' }
              ],
              corners_square_style: [
                { value: "", label: 'none' },
                { value: 'dot', label: 'dot' },
                { value: 'square', label: 'square' },
                { value: 'extra-rounded', label: 'extra-rounded' }
              ],
              corners_dot_style: [
                { value: "", label: 'none' },
                { value: 'dot', label: 'dot' },
                { value: 'square', label: 'square' }
              ],
            }}
            register={register}
            errors={errors}
            changeDataFunction={handleOnChangeData}
            changeDataBoolean={handleChangeBoolean}
            openImageManager={handleOpenImageManager}
            setFieldImageManager={handleFieldImageManager}
            changeCompletePicker={handleChangeCompletePicker} />
        </Grid>
        <Grid item xs={12} md={6}>
          { dataInstance !== undefined ? <div style={{ position: "sticky", top: 10, textAlign: "center" }}>
            <div ref={ref} />
            <div style={{ display: "flex", justifyContent: "space-evenly" }}>
              <NativeSelect onChange={handleOnExtensionChange} defaultValue={fileExt} >
                <option value="svg">SVG</option>
                <option value="png">PNG</option>
                <option value="jpeg">JPEG</option>
                <option value="webp">WEBP</option>
              </NativeSelect>
              <Button variant="contained" onClick={handleOnDownloadClick}>Download</Button>
            </div>
          </div> : <span>Cargando..</span> }
        </Grid>
      </Grid>
    </FlexibleWidthDialog>
    <DialogImageManager open={imageManagerModalOpen}
      actionClose={handleCloseImageManager}
      setImageSelected={handleSelectImageManager} />
  </>)
}